import { render, staticRenderFns } from "./staffPrivilege.vue?vue&type=template&id=339eae06&scoped=true"
import script from "./staffPrivilege.vue?vue&type=script&lang=js"
export * from "./staffPrivilege.vue?vue&type=script&lang=js"
import style0 from "./staffPrivilege.vue?vue&type=style&index=0&id=339eae06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339eae06",
  null
  
)

export default component.exports